import React from 'react';
import '../RSAShared.css';
import './RSAModelAnalysis.css';
import RSAAnalysis from '../RSAAnalysis';

function RSAModelAnalysis(props) {
  return <RSAAnalysis {...props} projectType="rsa-model" />;
}

export default RSAModelAnalysis;
